import React from 'react'
import QuoteRequestModalBlog from './quote-request-modal-blog';
import Modal from 'react-modal';
import QuoteStepsModal from './quote-steps-modal'

export default class ServicesDumpsters extends React.Component {
    constructor(props) {
        super(props)
        this.services = [
            {
                title: 'Temporary Dumpster Rental',
                code: 'dumpster',
                ondeffCode: 'dumpsterQuoteRequest',
                showButton: true,
                startVisible: false
            },
            {
                title: 'Full Service Junk Removal',
                code: 'junk-removal',
                ondeffCode: 'junkRemovalQuoteRequest',
                showButton: true,
                startVisible: false
            }
        ]
        this.state =
        {
            showModal: false
        }
    }

    changeShowModal = () => {
        this.setState({showModal: !this.state.showModal})
    }

    render() {
            return (

                <div className="services mb-5">
                    <h3>Select the Service You Need</h3>
                    <div className="card">
                        {this.services.map(service => (
                            <QuoteRequestModalBlog 
                                title={service.title}
                                code={service.code}
                                ondeffCode={service.ondeffCode}
                                showButton={service.showButton}
                                startVisible={service.startVisible}
                            />
                        ))}
                        <a href="#" className="service" data-keygroup="comercial-trash-service"  onClick={this.changeShowModal}>Permanent Commercial Waste</a>
                        <Modal
                            id={1}
                            isOpen={this.state.showModal}
                            style={{
                                content:
                                {
                                    top: '50%',
                                    left: '50%',
                                    right: 'auto',
                                    bottom: 'auto',
                                    borderRadius: '10px',
                                    border: 'none',
                                    backgroundColor: '#e8e8e8',
                                    marginTop: 'auto',
                                    marginBottom: 'auto',
                                    marginRight: '-50%',
                                    transform: 'translate(-50%, -50%)',
                                    padding: '0px 20px',
                                    width: '600px',
                                }
                            }}
                            contentLabel="Get a Quote!"
                            shouldCloseOnOverlayClick={false}
                            preventScroll={true}
                            ariaHideApp={false}
                        >
                            <QuoteStepsModal  env={this.props.env} closeModal={this.changeShowModal} />
                            </Modal>
                    </div>
                </div>

            )
    }

}
